import script from "./ProfileCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileCard.vue?vue&type=script&setup=true&lang=js"

import "./ProfileCard.vue?vue&type=style&index=0&id=47fb156c&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47fb156c"]])

export default __exports__